import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';

export function noOptionQuotesBuilder() {
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        The option you are attempting to trade has no quotes for today. Price
        data may be very inaccurate.
      </Body3>
    </td>
  );
}
